<template>
  <div>
    <el-table :data="projects">
      <el-table-column label="创建时间">
        <template slot-scope="scope">{{
          scope.row.createTime | moment
        }}</template>
      </el-table-column>
      <el-table-column prop="id" label="项目ID"></el-table-column>
      <el-table-column prop="coinType" label="支付币种"></el-table-column>
      <el-table-column
        prop="distributionCoinType"
        label="发放币种"
      ></el-table-column>
      <el-table-column prop="day" label="挖矿周期"></el-table-column>
      <el-table-column label="开售时间">
        <template slot-scope="scope">{{
          scope.row.buyStartTime | moment
        }}</template>
      </el-table-column>
      <el-table-column label="停售时间">
        <template slot-scope="scope">{{
          scope.row.buyEndTime | moment
        }}</template>
      </el-table-column>
      <el-table-column label="价格" prop="price"></el-table-column>
      <el-table-column label="发售总量" prop="totalFinancing"></el-table-column>
      <el-table-column label="已出售" prop="nowFinancing"></el-table-column>
      <el-table-column label="挖矿开始时间">
        <template slot-scope="scope">{{
          scope.row.startTime | moment
        }}</template>
      </el-table-column>
      <el-table-column label="挖矿结束时间">
        <template slot-scope="scope">{{ scope.row.endTime | moment }}</template>
      </el-table-column>
      <el-table-column prop="minMortgageAmount" label="状态">
        <template slot-scope="scope">
          <el-tag :type="orderList[scope.row.status].color">
            {{ orderList[scope.row.status].value }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-tooltip content="修改" v-show="scope.row.status == 0">
            <el-button
              type="primary"
              size="small"
              circle
              icon="el-icon-edit"
              @click="edit(scope.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="删除">
            <el-button
              type="danger"
              size="small"
              circle
              icon="el-icon-delete"
              @click="removeList(scope.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <detail @refresh="handleCurrentChange()"></detail>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Detail from '../detail';

export default {
  name: 'miningList',
  computed: {
    ...mapState('mining', ['projects', 'orderList'])
  },
  components: {
    Detail
  },
  methods: {
    ...mapActions('mining', ['remove', 'getList']),
    ...mapMutations('mining', ['setEditingProject']),
    edit(project) {
      this.setEditingProject(project);
    },
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    },
    removeList(row) {
      this.$confirm('确认要进行此操作吗？', '提示', { type: 'warning' }).then(
        () => {
          this.remove({
            borrowCoinType: row.borrowCoinType,
            mortgageCoinType: row.mortgageCoinType
          }).then(() => {
            this.$message.success('删除成功！');
            this.getList();
          });
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
.link-button {
  margin-left: 10px;
}
</style>
